import React from "react";
import { useLocation } from "react-router-dom";

interface Props {
  children: React.ReactNode;
  invertCheck?: boolean;
  requiredPath?: string;
  requiredAnyOfPaths?: string[];
}

const isPathEqual = (requiredPath: string, currentPath: string): boolean => {
  return requiredPath === currentPath;
};

export const isEqualToAnyOfPaths = (
  requiredAnyOfPaths: string[],
  currentPath: string
): boolean => {
  return (
    requiredAnyOfPaths.filter((path) => isPathEqual(path, currentPath)).length >
    0
  );
};

export const checkConditions = (
  currentPath: string,
  requiredPath?: string,
  requiredAnyOfPaths?: string[]
): boolean => {
  let isRequiredPathConditionMet = false;
  let isRequiredAnyOfPathsConditionMet = false;

  if (!requiredPath || isPathEqual(requiredPath, currentPath)) {
    isRequiredPathConditionMet = true;
  }

  if (
    !requiredAnyOfPaths ||
    requiredAnyOfPaths.length === 0 ||
    isEqualToAnyOfPaths(requiredAnyOfPaths, currentPath)
  ) {
    isRequiredAnyOfPathsConditionMet = true;
  }

  return isRequiredPathConditionMet && isRequiredAnyOfPathsConditionMet;
};

const LocationController = (props: Props) => {
  const location = useLocation();
  const { requiredPath, requiredAnyOfPaths, invertCheck, children } = props;

  if (!requiredPath && !requiredAnyOfPaths) {
    return <>{children}</>;
  }

  if (invertCheck) {
    if (
      !checkConditions(
        location.pathname + location.search,
        requiredPath,
        requiredAnyOfPaths
      )
    ) {
      return <>{children}</>;
    }
  } else if (
    checkConditions(
      location.pathname + location.search,
      requiredPath,
      requiredAnyOfPaths
    )
  ) {
    return <>{children}</>;
  }

  return null;
};

export default LocationController;
